import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";

const GET_DELAYED_START_SEVERITY_FREQUENCY_QUERY_KEY = "delayedStartSeverityFrequency";

async function getDelayedStartSeverityFrequency(
  tenantId: string,
  hospitalId: string,
  queryString: string = ""
) {
  const { data } = await fetcher({
    url: `analytics/delayed-start-severity-frequency?${queryString}`,
    method: "GET",
    headers: {
      "x-tenant-id": tenantId,
      "x-hospital-id": hospitalId,
    },
  });
  return data;
}

export default function useGetDelayedStartSeverityFrequencyQuery(
  tenantId: string,
  hospitalId: string,
  queryString: string = ""
) {
  return useQuery({
    queryKey: [GET_DELAYED_START_SEVERITY_FREQUENCY_QUERY_KEY, queryString, hospitalId],
    queryFn: () => getDelayedStartSeverityFrequency(tenantId, hospitalId, queryString),
    refetchInterval: 60000,
  });
} 